import { userConstants } from "../../constants/ActionTypes";

const changePassword={
    currentPassword:"",
    newPassword:"",
    confirmPassword:"",
    twoFactorAuth:"",
    profile:{},
    showPassword:false,
    showNewPassword:false,
    showConfirmPassword:true,
    create_mpin:"",
    confirm_mpin:"",
    showCreatePin:false,
    showConfirmPin:true,
    createMpinOtp:"",
    showLoginpassword:false,
    showPinScreen:false,
    showoldMpin:false,
    showNewPin:false,
    showConfirmNewPin:true,
    oldMpin:"",
    setNewPin:"",
    confirmNewMpin:"",
    transPinStatus:"",
    resetPinOtp:"",
    showResetPinScreenOtp:false,
    showRestPinSection:false,
    verify_login_password:"",
    showVerify_login_password:false,
    showlogin_password_create:false,
    pin_enabled: false,
    twoFactorAuthStatus:"",
    showOtpCreate:false
}


export function change_password(state = changePassword, action) {
    switch (action.type) {  
        case userConstants.CHANGE_PASSWORD:
            return {
                ...state,
                ...action.payload
            };
        case userConstants.MERCHANT_PROFILE:
            return {
                ...state,
                 ...action.payload
                };
        default:
            return state
    }
}


